export type ResourceTagResourceType =
  | "canvas"
  | "workspace"
  | "skill"
  | "file-record"
  | "integration-connection";

/** The only system tag we support today. */
export const RESOURCE_TAG_FAVORITE = "favorite";

export interface CreateResourceTagRequest {
  resource_type: ResourceTagResourceType;
  resource_id: string;
  tag_key?: string;
}

export interface ResourceTag {
  id: string;
  resource_type: string;
  resource_id: string;
  tag_key: string;
  created_at: string;
}

export interface ResourceTagResponse {
  data: {
    resource_tag: ResourceTag;
  };
}
